import {
  Checkbox,
  FormControlLabel,
  ListItem,
  ListItemText,
  Typography
} from '@mui/material'

import { ServiceEntry, ServiceExpanded, ServiceInfoStatusEnum } from '../../sdk'
import { formatCurrency } from '../../utils'

interface Props {
  service: ServiceExpanded
  isCustomerVersion: boolean
  showPrice: boolean
  handleDeferOrRecommendService?: (
    service: ServiceEntry,
    isDeferral: boolean
  ) => Promise<void>
}

const ServiceListItem = ({
  service,
  isCustomerVersion,
  showPrice,
  handleDeferOrRecommendService
}: Props) => {
  const isRecommended =
    service.entry?.info?.status === ServiceInfoStatusEnum.Recommended

  return (
    <ListItem
      key={service.entry?.id}
      sx={{ bgcolor: '#EAE7F8', borderRadius: 2, marginY: 1 }}>
      {isCustomerVersion ? (
        <ListItemText
          primary={
            <Typography variant="h6" color="primary.main">
              Recommended Service
            </Typography>
          }
          secondary={service.entry?.info?.title}
        />
      ) : (
        <ListItemText primary={service.entry?.info?.title} />
      )}
      {isCustomerVersion && showPrice && (
        <FormControlLabel
          control={
            <Checkbox
              edge="start"
              disableRipple
              checked={isRecommended || false}
              onClick={() =>
                handleDeferOrRecommendService
                  ? handleDeferOrRecommendService(service.entry!, isRecommended)
                  : {}
              }
            />
          }
          label={`Add to Cart - ${formatCurrency(
            service.cachedRetailPrice!,
            true
          )}`}
          sx={{
            border: '1px solid rgba(0, 0, 0, 0.24)',
            borderRadius: 2,
            paddingX: 2
          }}
        />
      )}
    </ListItem>
  )
}

export default ServiceListItem
